<template>
  <div>
    <v-slide-y-transition>
      <div v-if="ready">
        <SectionHeader key="SectionHeader" />

        <SectionLoanSummary key="SectionLoanSummary" />

        <SectionReason key="SectionReason" />

        <SectionFaq key="SectionFaq" />

        <SectionFooter key="SectionFooter" />
      </div>
    </v-slide-y-transition>

    <v-footer fixed>
      <v-layout>
        <KakaoButton
          :classes="['font-size--20', 'font-weight-black', 'rounded-16']"
          style="box-shadow: 0 8px 14px 0 rgba(0, 0, 0, 0.14)"
          height="64"
        />
      </v-layout>
    </v-footer>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import { getRedirectUriAndRemove } from '@/util'

export default {
  components: {
    SectionHeader: () => import('./fundanow-style/SectionHeader.vue'),
    SectionLoanSummary: () => import('./fundanow-style/SectionLoanSummary.vue'),
    SectionReason: () => import('./fundanow-style/SectionReason.vue'),
    SectionFaq: () => import('./fundanow-style/SectionFaq.vue'),
    SectionFooter: () => import('./fundanow-style/SectionFooter.vue'),
    KakaoButton: () => import('@/components/signup/KakaoButton.vue'),
  },
  data() {
    return {
      ready: false,
      openModal: false,
    }
  },
  mounted() {
    this.ready = true
  },
  created() {
    _meta({
      titles: ['펀다에이아이x중소벤처기업부', '우리동네크라우드펀딩'],
    })
    // 로그인을 하지않았고 acquisitionRoute가 없을때 쿠키에 acquisitionRoute를 저장한다.
    const acquisitionRouteName = 'acquisitionRoute'
    const acquisitionRoute = this.$cookies.get(acquisitionRouteName)
    if (!this.me && !acquisitionRoute) {
      this.$cookies.set(acquisitionRouteName, 'woori_crowd')
    }
  },
  computed: {
    ...mapState('auth', ['me']),
  },
}
</script>

<style lang="scss" scoped></style>
